import { useEffect } from 'react'
import { Box } from '@mui/material'
import { useOnboarding } from '../context/OnboardingContext'

export function WizardToast() {
  const { state, dispatch } = useOnboarding()

  useEffect(() => {
    if (!state.toast) return
    const t = window.setTimeout(() => dispatch({ type: 'CLEAR_TOAST' }), 3200)
    return () => window.clearTimeout(t)
  }, [state.toast, dispatch])

  if (!state.toast) return null

  return (
    <Box
      role="status"
      sx={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        zIndex: 100,
        maxWidth: 448,
        transform: 'translateX(-50%)',
        borderRadius: 2,
        backgroundColor: '#0f172a',
        px: 2,
        py: 1.25,
        textAlign: 'center',
        fontSize: 14,
        color: '#ffffff',
        boxShadow: 6,
      }}
    >
      {state.toast}
    </Box>
  )
}
